/**
 * ТЗ №2 §10.2 для диаграммы Ганта с несколькими камерами: общая ось времени
 * подписывается в единой зоне, если у всех камер одна display_timezone;
 * при смешанном scope ось — UTC (как trend_timezone у backend), а tooltip
 * каждой строки — в зоне своей камеры.
 */
export const pickGanttAxisTimezone = (cameras) => {
  const zones = [...new Set((cameras || []).map((camera) => camera?.display_timezone).filter(Boolean))];
  if (zones.length === 0) return { tz: undefined, mixed: false };
  if (zones.length === 1) return { tz: zones[0], mixed: false };
  return { tz: 'UTC', mixed: true };
};

export const describeGanttAxisTimezone = ({ tz, mixed }) => {
  if (mixed) return 'Время показано в локальном часовом поясе каждой камеры · ось времени в UTC';
  return tz ? `Часовой пояс ${tz}` : '';
};
